import { partnerRequest } from '../services/request.service'

const API_URL = window.env ? window.env.API_SERVER : '';
const NO_CONTENT = 2;
const REQUEST_FAILURE = 1;
const REQUEST_SUCCESS = 0;

const impactStatementsRequest = 'JOURNAL_LIST_REQUEST';
const impactStatementsSuccess = 'JOURNAL_LIST_SUCCESS';
const impactStatementsFailure = 'JOURNAL_LIST_FAILURE';

const initialState = {
    impactStatements: [],
    impactStatementMessage: '',
};

export const impactStatementActionCreators = {
    requestImpactStatements: () => ({
        type: impactStatementsRequest,
        impactStatements: [],
        isFetching: true
    }),

    receiveImpactStatements: (statements, message) => ({
        type: impactStatementsSuccess,
        isFetching: false,
        impactStatements: statements,
        impactStatements: message
    }),

    impactStatementsError: (message) => ({
        type: impactStatementsFailure,
        isFetching: false,
        impactStatements: [],
        impactStatementsMessage: message
    }),

    getImpactStatements: (params) => {
        return dispatch => {
            dispatch(impactStatementActionCreators.requestImpactStatements());

            let headers = {
                'content-type': "application/json; charset=utf-8"
            }
            return partnerRequest((API_URL || process.env.REACT_APP_JOURNAL_API_URL) + '/ImpactStatementFileGeneration/api/GetImpactStatementData?', 'GET', headers, '', params)
                .then(result => {
                    if (result[0] === REQUEST_FAILURE) {
                        dispatch(impactStatementActionCreators.impactStatementsError(result[1]))
                        return Promise.reject(result[1])
                    } else if (result[0] === REQUEST_SUCCESS) {
                        // Dispatch the success action
                        dispatch(impactStatementActionCreators.receiveImpactStatements(result[1].ImpactStatements))
                    } else if (result[0] === NO_CONTENT) {
                        dispatch(impactStatementActionCreators.receiveImpactStatements([]));
                    } else if (result.name === 'AbortError') {
                        return Promise.reject("Aborted");
                    }
                }).catch(err => Promise.reject(err))
        }
    }
}

export const reducer = (state, action) => {

    state = state || initialState;

    switch (action.type) {
        case impactStatementsRequest:
            return Object.assign({}, state, {
                isFetching: true
            })
        case impactStatementsSuccess:
            return Object.assign({}, state, {
                isFetching: false,
                impactStatements: action.impactStatements,
                impactStatementMessage: ''
            })
        case impactStatementsFailure:
            return Object.assign({}, state, {
                isFetching: false,
                impactStatements: action.impactStatements,
                impactStatementsMessage: action.impactStatementsMessage
            })
        default:
            return state
    }
};